<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-3D1`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_55fac25c11__clip0_19206_127464)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.18962 4.19086L8.4221 0.481306C8.70473 0.336346 9.03941 0.334276 9.32381 0.475729L16.7992 4.19381C17.139 4.36283 17.3538 4.70965 17.3538 5.08917V12.4163C17.3538 12.7772 17.1593 13.1102 16.8448 13.2874L9.37012 17.4996C9.06124 17.6737 8.68329 17.6712 8.37674 17.493L1.14356 13.2897C0.835531 13.1107 0.645996 12.7814 0.645996 12.4251V5.08065C0.645996 4.70557 0.855884 4.36204 1.18962 4.19086ZM2.36708 4.87611L8.80097 1.58047C8.85744 1.55154 8.9243 1.55113 8.98112 1.57936L15.646 4.89C15.6277 4.89768 15.6095 4.90627 15.5916 4.91578L8.98742 8.4196L6.99713 7.33872L6.99714 7.3387L6.993 7.33649L2.45917 4.91654C2.42908 4.90048 2.3983 4.88703 2.36708 4.87611ZM1.87061 6.07599V12.2865C1.87061 12.3577 1.90856 12.4237 1.97022 12.4594L8.29575 16.1305C8.29462 16.1149 8.29405 16.0991 8.29405 16.0832V9.52238L6.3788 8.48225L1.87061 6.07599ZM9.59405 16.08L16.0281 12.459C16.0911 12.4236 16.13 12.3569 16.13 12.2847V6.10174L9.59405 9.56939V16.08Z"/></g><defs><clipPath id="svg_55fac25c11__clip0_19206_127464"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'Icon3D1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
